module.exports = __webpack_public_path__ + "static/img/list-item-6.b23abf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-item-6.png
// module id = Kb8J
// module chunks = 1